import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
import { assertUnreachable } from 'common/util/typescript';
import { WARNING_THEMES } from './types';
export function template() {
  const theme = this.attr("theme");
  const href = this.attr("cta-href");
  const classNames = [".mp-warning-content"];
  let icon = null;

  switch (theme) {
    case WARNING_THEMES.ERROR:
      icon = jsx(SvgIconEl, {
        attrs: {
          icon: "warning"
        }
      });
      classNames.push(".warning-error");
      break;

    case WARNING_THEMES.SENSITIVE:
      icon = jsx(SvgIconEl, {
        attrs: {
          icon: "lock"
        }
      });
      classNames.push(".warning-sensitive");
      break;

    case WARNING_THEMES.ERROR_DARK:
      icon = jsx(SvgIconEl, {
        attrs: {
          icon: "warning"
        }
      });
      classNames.push(".error-dark");
      break;

    case WARNING_THEMES.DEFAULT:
      icon = jsx("div", {
        sel: '.mp-warning-laptop-svg'
      }); // no color since it is the colored laptop svg

      break;

    case WARNING_THEMES.NO_ICON:
      break;

    default:
      assertUnreachable(theme);
  }

  let bodyText = null;

  if (this.attr("body-text")) {
    bodyText = jsx("div", {
      sel: '.body-text'
    }, this.attr("body-text").split("\n").map((line, idx) => jsx(null, null, idx ? jsx("br", null) : null, line)));
  }

  return jsx("div", {
    sel: '.mp-warning-container'
  }, jsx("div", {
    sel: classNames.join("")
  }, icon, this.attr("header-text") && jsx("h1", null, this.attr("header-text")), bodyText), jsx("slot", null), this.attr("cta-text") && jsx("a", {
    sel: '.mp-warning-cta',
    attrs: {
      href
    },
    on: {
      click: href ? null : this.helpers.handleCtaClick
    }
  }, this.attr("cta-text"), jsx(SvgIconEl, {
    attrs: {
      icon: "arrow-right"
    }
  })));
}